import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";
import { SelectUppercaseInput } from "./SelectUppercaseInput";

export const CoolerTypeSelect = ({ source = "cooler_type_id", uppercase = false, ...props }) => (
	<ReferenceInput {...props} source={source} reference="cooler-types">
		{uppercase ? <SelectUppercaseInput optionText="name" /> : <SelectInput optionText="name" />}
	</ReferenceInput>
);
